import { useState } from 'react';

import { Card, Form, Button, Alert } from 'react-bootstrap';

export const StepCredentials = ({ initialValue, onBack, onNext }) => {

    const [username, setUsername] = useState(initialValue?.username || '');
    const [password, setPassword] = useState(initialValue?.password || '');

    const submit = e => {

        e.preventDefault();
        const credentials = (username || password) ? { password, username } : null;
        onNext(credentials);

    };

    const skip = () => onNext(null);

    return (

        <Card>
            <Card.Body>

                <Card.Title>
                    Credentials
                    <small className="text-muted fw-normal">
                        (optional)
                    </small>
                </Card.Title>
                <Card.Subtitle className="text-muted mb-3">
                    Used only if your test plan requires logging in.
                </Card.Subtitle>

                <Alert className="border small" variant="light">
                    Credentials live in your browser's session memory. They are never sent
                    to the backend, never persisted, never logged.
                </Alert>

                <Form onSubmit={submit}>

                    <Form.Group className="mb-3" controlId="step-username">
                        <Form.Label>
                            Username
                        </Form.Label>
                        <Form.Control
                            autoComplete="off"
                            onChange={e => setUsername(e.target.value)}
                            type="text"
                            value={username}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" controlId="step-password">
                        <Form.Label>
                            Password
                        </Form.Label>
                        <Form.Control
                            autoComplete="off"
                            onChange={e => setPassword(e.target.value)}
                            type="password"
                            value={password}
                        />
                    </Form.Group>

                    <div className="d-flex justify-content-between">

                        <Button onClick={onBack} variant="outline-secondary">
                            Back
                        </Button>

                        <div className="d-flex gap-2">
                            <Button onClick={skip} variant="outline-primary">
                                Skip
                            </Button>
                            <Button type="submit" variant="primary">
                                Next
                            </Button>
                        </div>

                    </div>

                </Form>

            </Card.Body>
        </Card>

    );

};
